import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";
import { useEffect, useState } from "react";
import { useRltWorkOrderUpdateStateMutation } from "@/services/backend/rlt/work-orders/api/work-order-api";

export function StartExecutionDialog({ workOrder }: { workOrder: WorkOrder }) {
  const [open, setOpen] = useState(false);
  const [patch, { isLoading, error, isSuccess, reset }] =
    useRltWorkOrderUpdateStateMutation();

  useEffect(() => {
    if (isSuccess) {
      setOpen(false);
      reset();
    }
  }, [isSuccess, reset]);

  const doForward = () => {
    if (isLoading) return;

    patch({
      id: workOrder.id,
      state: FulfillmentState.Execution,
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button>{t("Ausführung beginnen")}</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Ausführung beginnen?")}</DialogTitle>
          <DialogDescription>
            {t(
              'Der Arbeitsschein wird als in "Ausführung" markiert. Er wird für alle Mitarbeiter mit Zugriff auf Arbeitsscheine in der Ausführung sichtbar.',
            )}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} ignoreValidationError={false} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doForward} />
      </DialogContent>
    </Dialog>
  );
}
